import type { ButtonHTMLAttributes, ReactNode } from "react";
import { Spinner } from "./Spinner.tsx";
import s from "./primitives.module.css";

export type ButtonVariant = "primary" | "buy" | "sell" | "ghost";
/** `busy` is a THIRD state, not "disabled with a spinner": it must announce itself (`aria-busy`) and it must
 *  not be reachable by a second click, because the two clicks the money path fears most are a double-submit and
 *  a re-press during signing. */
export type ButtonState = "idle" | "busy" | "disabled";

export interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "disabled"> {
  variant?: ButtonVariant;
  state?: ButtonState;
  children?: ReactNode;
}

export function Button({
  variant = "ghost",
  state = "idle",
  children,
  className,
  ...rest
}: ButtonProps) {
  const busy = state === "busy";
  const classes = [s.button, s[variant], className].filter(Boolean).join(" ");
  return (
    <button
      type="button"
      className={classes}
      disabled={busy || state === "disabled"}
      aria-busy={busy || undefined}
      {...rest}
    >
      {busy ? <Spinner /> : null}
      {children}
    </button>
  );
}
